"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var AnalyticsProvider_1 = __importDefault(require("../AnalyticsProvider"));
var AutoNationProvider = /** @class */ (function (_super) {
    __extends(AutoNationProvider, _super);
    function AutoNationProvider(name, config) {
        var _this = _super.call(this, name) || this;
        _this.config = config;
        return _this;
    }
    /**
     * If we were passed an eventCallback, send the payload there.
     *     This is typical in Electric, where we want to push onto the parent window (dealer website) dataLayer.
     * If we were *not* passed an eventCallback, look for window.dataLayer.push in our context
     *     This is typical in Redline
     * Note that Google replaces the entire window.dataLayer object when it finishes loading, it is *not* safe to hold onto a reference to the push method directly.
     * @param payload
     * @protected
     */
    AutoNationProvider.prototype.eventHandler = function (payload) {
        var eventHandler = this.config.eventCallback || window.dataLayer.push;
        eventHandler(payload);
    };
    /** Initial Form Load - this event fires when the payment builder load */
    AutoNationProvider.prototype.paymentCalcViewed = function (dealId, vehicle) {
        var pageTypeLower = this.config.pageType.toLowerCase();
        this.eventHandler({
            category_l1: this.config.pageType,
            category_l2: "(not set)",
            category_l3: "(not set)",
            category_l4: "(not set)",
            form_actual_name: pageTypeLower + "-payment-options",
            form_name: pageTypeLower + "_form",
            form_open_button_click: 1,
            form_load_page1: 1,
            form_page_load: 1,
            pagegroup: "" + pageTypeLower,
            event: "form_load",
            event_category: "Lead Submission",
            event_action: "Lead Submission_" + this.config.pageType + "|||Payment_Options",
            event_label: "Payment Options-Form Load",
            event_value: 1,
            enh_action: "add",
            enh_vehic_brand: vehicle.make,
            enh_vehic_category: vehicle.type,
            enh_vehic_discount: "(not set)",
            enh_vehic_id: vehicle.vin,
            enh_vehic_list: "(not set)",
            enh_vehic_name: vehicle.year + " " + vehicle.make + " " + vehicle.model + " " + vehicle.trim,
            enh_vehic_position: vehicle.rating,
            enh_vehic_price: vehicle.msrp,
            enh_vehic_quantity: 1,
            enh_vehic_variant: "(not set)",
        });
    };
    //Form Started  - one time
    AutoNationProvider.prototype.leadFormStarted = function (dealId, vehicle) {
        var _this = this;
        this.handleOnlyOncePerSession("leadFormStarted", function () {
            var pageTypeLower = _this.config.pageType.toLowerCase();
            _this.eventHandler({
                category_l1: _this.config.pageType,
                category_l2: "(not set)",
                category_l3: "(not set)",
                category_l4: "(not set)",
                form_actual_name: pageTypeLower + "-payment-options",
                form_name: pageTypeLower + "_form",
                form_started: 1,
                event: "form_started",
                event_category: "Lead Submission",
                event_action: "Lead Submission_" + _this.config.pageType + "|||Payment_Options",
                event_label: "Payment Options-Form Started",
                event_value: 1,
                pagegroup: "" + pageTypeLower,
                enh_action: "checkout",
                enh_vehic_brand: vehicle.make,
                enh_vehic_category: vehicle.type,
                enh_vehic_discount: "(not set)",
                enh_vehic_id: vehicle.vin,
                enh_vehic_list: "(not set)",
                enh_vehic_name: vehicle.year + " " + vehicle.make + " " + vehicle.model + " " + vehicle.trim,
                enh_vehic_position: vehicle.rating,
                enh_vehic_price: vehicle.msrp,
                enh_vehic_quantity: 1,
                enh_vehic_variant: "(not set)",
                enh_checkout_option: "(not set)",
                enh_checkout_step: 1,
            });
        });
    };
    // Form Load Page2
    AutoNationProvider.prototype.virtualPageView = function (page) {
        if (!page.includes("/online-shopper/create")) {
            return;
        }
        var pageTypeLower = this.config.pageType.toLowerCase();
        this.eventHandler({
            category_l1: this.config.pageType,
            category_l2: "(not set)",
            category_l3: "(not set)",
            category_l4: "(not set)",
            form_actual_name: pageTypeLower + "-payment-options",
            form_name: pageTypeLower + "_form",
            form_load_page2: 1,
            form_page_load: 1,
            pagegroup: "" + pageTypeLower,
        });
    };
    //Lead Submission/Form Success
    AutoNationProvider.prototype.leadFormFinished = function (dealdId, vehicle) {
        var pageTypeLower = this.config.pageType.toLowerCase();
        //Submit Initiated
        this.eventHandler({
            category_l1: this.config.pageType,
            category_l2: "(not set)",
            category_l3: "(not set)",
            category_l4: "(not set)",
            form_actual_name: pageTypeLower + "-payment-options",
            form_name: pageTypeLower + "_form",
            submit_initiated: 1,
            pagegroup: "" + pageTypeLower,
            event: "submit_initiated",
            event_category: "Lead Submission",
            event_action: "Lead Submission_" + this.config.pageType + "|||Payment_Options",
            event_label: "Payment Options-Submit Initiated",
            event_value: 1,
        });
        //Lead Submission
        this.eventHandler({
            category_l1: this.config.pageType,
            category_l2: "(not set)",
            category_l3: "(not set)",
            category_l4: "(not set)",
            form_actual_name: pageTypeLower + "-payment-options",
            form_name: pageTypeLower + "_form",
            event: "lead_submission",
            event_category: "Lead Submission",
            event_action: "Lead Submission_" + this.config.pageType + "|||Payment_Options",
            event_label: "Payment Options-Lead Submission",
            event_value: 1,
            lead_submission: 1,
            lead_vin: vehicle.vin,
            lead_inv_type: vehicle.type,
            lead_make: vehicle.make,
            lead_make_yr: vehicle.year,
            lead_make_model: vehicle.model,
            lead_hyperion: "(not set)",
            lead_store_name: "(not set)",
            lead_provider_id: "(not set)",
            lead_contact_method: "(not set)",
            pagegroup: "" + pageTypeLower,
        });
        //Form Success
        this.eventHandler({
            category_l1: this.config.pageType,
            category_l2: "(not set)",
            category_l3: "(not set)",
            category_l4: "(not set)",
            form_actual_name: pageTypeLower + "-payment-options",
            form_name: pageTypeLower + "_form",
            form_success: 1,
            pagegroup: "" + pageTypeLower,
            event: "form_success",
            event_category: "Lead Submission",
            event_action: "Lead Submission_" + this.config.pageType + "|||Payment_Options",
            event_label: "Payment Options-Form Success",
            event_value: 1,
            enh_action: "purchase",
            enh_vehic_brand: vehicle.make,
            enh_vehic_category: vehicle.type,
            enh_vehic_discount: "(not set)",
            enh_vehic_id: vehicle.vin,
            enh_vehic_list: "(not set)",
            enh_vehic_name: vehicle.year + " " + vehicle.make + " " + vehicle.model + " " + vehicle.trim,
            enh_vehic_position: vehicle.rating,
            enh_vehic_price: vehicle.msrp,
            enh_vehic_quatity: 1,
            enh_vehic_variant: "(not set)",
            enh_checkout_option: "(not set)",
            enh_transaction_id: dealdId,
            enh_booking_value: vehicle.msrp,
        });
    };
    return AutoNationProvider;
}(AnalyticsProvider_1.default));
exports.default = AutoNationProvider;
